import { Button, FontWeights, Text } from "@flat-ui";
import { UlmContainer } from "@components/ulm/ulm-container";
import { Box } from "@mui-wrapper";
import FaroWarningIcon from "@assets/icons/warning.svg?react";
import { HandledError } from "@context-providers/error-handler/error-handler-types";
import { useAppNavigation } from "@hooks/use-app-navigation";
import { useCallback } from "react";
import { ErrorDetailMessage } from "@context-providers/error-handler/error-detail-message";

interface Props {
  /** The error to be shown in toast */
  error: HandledError;

  /** Callback to close error page */
  close?: () => void;
}

/** Error page with information about the error and action buttons */
export function ErrorPage({ error, close }: Props): JSX.Element {
  const { navigateToLogin } = useAppNavigation();

  /** Closes error page and navigates to login */
  const closeAndGoToLogin = useCallback(() => {
    close?.();
    navigateToLogin();
  }, [close, navigateToLogin]);

  return (
    <UlmContainer>
      <Box
        sx={{
          marginTop: "100px",
          fontSize: "20px",
          textAlign: "center",
        }}
      >
        <FaroWarningIcon
          style={{
            marginRight: "10px",
          }}
        />
        {error.title}
      </Box>

      <Box
        sx={{
          marginTop: "40px",
        }}
      >
        <Text
          variant="bodyL"
          component="p"
          sx={{
            fontWeight: FontWeights.Bold,
          }}
        >
          Developer Error Message:
        </Text>
        <ErrorDetailMessage error={error.error} />
      </Box>

      <Box
        sx={{
          marginTop: "40px",
          width: "100%",
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        <Button onClick={closeAndGoToLogin} variant="secondary">
          Return to log in
        </Button>

        <Button onClick={() => window.location.reload()} variant="secondary">
          Reload
        </Button>
      </Box>
    </UlmContainer>
  );
}
